import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { Link } from "react-router-dom";
import { GalleryCard, Gallery } from "../portfolio/GalleryCard";
import { PortfolioGrid } from "../portfolio/PortfolioGrid";

interface RelatedGalleriesProps {
  currentGalleryId: string;
  currentCategory: string;
  allGalleries: Gallery[];
  maxGalleries?: number;
}

export const RelatedGalleries: React.FC<RelatedGalleriesProps> = ({
  currentGalleryId,
  currentCategory,
  allGalleries,
  maxGalleries = 4,
}) => {
  // Filter out current gallery and find related ones
  const relatedGalleries = allGalleries
    .filter(
      (gallery) =>
        gallery.id !== currentGalleryId &&
        (gallery.category === currentCategory || !currentCategory)
    )
    .slice(0, maxGalleries);

  // If not enough related by category, add recent galleries
  if (relatedGalleries.length < maxGalleries) {
    const additional = allGalleries
      .filter(
        (gallery) =>
          gallery.id !== currentGalleryId &&
          !relatedGalleries.some((rg) => rg.id === gallery.id)
      )
      .slice(0, maxGalleries - relatedGalleries.length);
    relatedGalleries.push(...additional);
  }

  if (relatedGalleries.length === 0) {
    return null;
  }

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 6, md: 8 },
        px: { xs: 2, sm: 3, md: 4 },
        backgroundColor: "background.default",
      }}
      aria-label="Related galleries"
    >
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          component="h2"
          sx={{
            fontFamily: '"Cinzel Decorative", serif',
            fontSize: { xs: "1.75rem", md: "2.25rem" },
            fontWeight: 400,
            mb: { xs: 3, md: 4 },
            textAlign: "center",
            color: "text.primary",
          }}
        >
          Related Galleries
        </Typography>
        <PortfolioGrid galleries={relatedGalleries} title="" />
      </Container>
    </Box>
  );
};
